module.exports = __webpack_public_path__ + "media/images/icon-rest-69a03cfcc11b432ff9c56bfa17c5606e.png";